<template>
  <div class="text-center image-container">
    <router-link to="/login">
      <img src="assets/getStartedBtn.png" class="getting-started-img" alt="" height="210" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "AppLanding"
}
</script>

<style lang="css" scoped>
</style>
